module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Americans-The-S6.c1e2342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Americans-The-S6.jpg
// module id = v7fX
// module chunks = 0